import { MonthContainer } from './MonthContainer.jsx';

export const PlanTabMonth = props => {
  const { bucket, month } = props;

  return (
    <MonthContainer
      createNewTilesDigest={props.createNewTilesDigest}
      isCollapsed={bucket.collapsed}
      setIsCollapsed={collapsed => props.toggleMonthCollapse(month, collapsed)}
      month={month}
      monthId={bucket.id}
      tileDigests={bucket.digests}
      tilesCount={bucket.tileCount}
      digestCount={bucket.digestCount}
      year={bucket.year}
    />
  );
};
